import ReservationSidebar from '../Commun/ReservationSidebar'
import ReservationHeader from '../Commun/ReservationHeader'
import { fetchVoucherDetails } from '../../Redux/Slices/reservationVoucherSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useEffect } from 'react';

export const VoucherDetail = () => {
    const { bonresid } = useParams();
    const dispatch = useDispatch();

    const { data, loading } = useSelector((state) => state.voucher);

    useEffect(() => {
        if (bonresid) {
            dispatch(fetchVoucherDetails(bonresid));
        }
    }, [bonresid, dispatch]);


    const header = data?.Table?.[0];
    const rooms = data?.Table1 || [];
    const hotelInfo = data?.Table3?.[0];
    const bookingInfo = data?.Table4?.[0];


    return (
        <>
            {loading && (
                <div className="fullscreen-loader">
                    <div className="fas fa-spinner fa-spin fa-3x " role="status"></div>
                </div>
            )}
            <div className="wrapper ">
                <ReservationSidebar />
                <div className="main-panel">
                    <ReservationHeader />

                    <div className="container">
                        <div className="page-inner">

                            <div className="card shadow-sm p-4">



                                <div className="row">

                                    {/* LEFT SIDE */}
                                    <div className="col-md-5 border-end">
                                        <div className="bg-light p-3" style={{ height: "250px" }}>
                                            <h6 className="text-muted fw-bold">GUEST DETAILS</h6>

                                            <div className="">
                                                <h5 className="fw-bold">
                                                    <i className="bi bi-person-fill me-2"></i>
                                                    {header?.FirstName} {header?.LastName}
                                                </h5>
                                            </div>

                                            <hr />
                                            <div className="row">
                                                <div className="col-6">
                                                    <p className="text-muted mb-1">CHECK-IN</p>
                                                    <p className="fw-bold mb-0">{bookingInfo?.CheckInDate}</p>
                                                </div>

                                                <div className="col-6">
                                                    <p className="text-muted mb-1">CHECK-OUT</p>
                                                    <p className="fw-bold mb-0">{bookingInfo?.CheckOutDate}</p>
                                                </div>
                                            </div>

                                            <div className="mt-4">
                                                <p className="text-muted mb-1">TOTAL NO. OF GUEST(S)</p>
                                                <p className="fw-bold">{header?.Adult} Adults + {header?.Child} Child</p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* RIGHT SIDE */}
                                    <div className="col-md-7  ">
                                        <div className="bg-light p-3" style={{ height: "250px" }}>
                                            <div className="row mb-3">
                                                <div className="col-md-6">
                                                    <p className="text-muted mb-1">BOOKING ID</p>
                                                    <p className="fw-bold">{bookingInfo?.BONRESID}</p>
                                                </div>

                                                <div className="col-md-6">
                                                    <p className="text-muted mb-1">BOOKED ON</p>
                                                    <p className="fw-bold">
                                                        {header?.BookingDate}
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="row mb-3">
                                                <div className="col-md-6">
                                                    <p className="text-muted mb-1">BOOKING STATUS</p>
                                                    <span className="badge bg-success">{bookingInfo?.BookingStatus}</span>
                                                </div>

                                                <div className="col-md-6">
                                                    <p className="text-muted mb-1">PAYMENT STATUS</p>
                                                    <span className="badge bg-warning">{bookingInfo?.PaymentStatus}</span>
                                                </div>
                                            </div>

                                            <div className="row mb-3">
                                                <div className="col-md-6">
                                                    <p className="text-muted mb-1">BOOKING SOURCE</p>
                                                    <p className="fw-bold">Book On Nile</p>
                                                </div>

                                                <div className="col-md-6">
                                                    <p className="text-muted mb-1">CONFERMATION NO</p>
                                                    <p className="fw-bold">{bookingInfo?.PMSRESID}</p>
                                                </div>
                                            </div>




                                        </div>
                                    </div>
                                </div>

                                <div className="mt-3" style={{ borderBottom: "2px solid #333" }}></div>
                                {/* 
                                <div style={{ borderBottom: "2px solid #333" }}>
                                   
                                    <h5 className="fw-bold mt-3">2 Room(s)</h5>

                                   
                                    <h6 className="fw-bold">
                                        1 x 1 King Bed, Sunrise Garden Villa, Non-Smoking
                                    </h6>
                                    <div className="ms-3 border-start ps-3 mb-3" style={{ borderColor: "#ccc", borderWidth: "2px" }}>

                                        <div className="text-muted mb-2">
                                            3 Adults &nbsp; • &nbsp; Breakfast
                                        </div>

                                     
                                        <div className="mb-2">
                                            <p className="fw-bold mb-1">Inclusions</p>
                                            <ul className="mb-2">
                                                <li>Complimentary Breakfast is available.</li>
                                                <li>OTA Retail Advance Purchase 1</li>
                                                <li>
                                                    15% discount on Food & Beverages available. Drinks will include Soft
                                                    Beverages.
                                                </li>
                                            </ul>
                                        </div>

                                     
                                        <div>
                                            <p className="fw-bold mb-1">Cancellation Policy</p>
                                            <ul>
                                                <li>
                                                    This tariff cannot be cancelled with zero fee. Any cancellations will
                                                    be subject to a hotel fee as follows: From 2026-02-17 17:34:16
                                                    (destination time) till 2026-03-26 13:59:59 (destination time) –
                                                    100% of booking amount. After 2026-03-26 14:00:00 (destination time)
                                                    – 100% of booking amount. Cancellations are only allowed before
                                                    CheckIn.
                                                </li>
                                            </ul>
                                        </div>

                                    </div>

                                 
                                    <h6 className="fw-bold">
                                        1 x 1 King Bed, Deluxe Room
                                    </h6>
                                    <div className="ms-3 border-start ps-3 mb-3" style={{ borderColor: "#ccc", borderWidth: "2px" }}>
                                        <div className="text-muted mb-2">
                                            1 Adult + 1 Child (12 years) &nbsp; • &nbsp; Breakfast
                                        </div>

                                       
                                        <div className="mb-2">
                                            <p className="fw-bold mb-1">Inclusions</p>
                                            <ul className="mb-2">
                                                <li>OTA Retail Advance Purchase 1</li>
                                                <li>
                                                    15% discount on Food & Beverages available. Drinks will include Soft
                                                    Beverages.
                                                </li>
                                                <li>Complimentary Breakfast is available.</li>
                                            </ul>
                                        </div>

                                       
                                        <div>
                                            <p className="fw-bold mb-1">Cancellation Policy</p>
                                            <ul>
                                                <li>
                                                    This tariff cannot be cancelled with zero fee. Any cancellations will
                                                    be subject to a hotel fee as follows: From 2026-02-17 17:34:16
                                                    (destination time) till 2026-03-26 13:59:59 (destination time) –
                                                    100% of booking amount. After 2026-03-26 14:00:00 (destination time)
                                                    – 100% of booking amount. Cancellations are only allowed before
                                                    CheckIn.
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                </div> */}
                                {/* ================= PAYMENT SECTION ================= */}
                                {/* <div style={{ borderBottom: "2px solid #333" }}>
                                    <h5 className="fw-bold mt-3">Payment</h5>

                                    <div className="row ">
                                        <div className="col-md-6">
                                            <p className="mb-1">Property Gross Charges</p>
                                            <h6 className="fw-bold">₹ 33,560.96</h6>
                                        </div>

                                        <div className="col-md-6 text-md-end">
                                            <p className="mb-1">Payable to Property</p>
                                            <h6 className="fw-bold">₹ 28,101.73</h6>
                                        </div>
                                    </div>

                                    <p className="text-muted " style={{ fontSize: "14px" }}>
                                        Go-MMT will release payment by 25th Mar, 2026. Payment generally takes 3-4 days
                                        to get credited to your account post release from our side.
                                    </p>
                                </div> */}

                                {/* ================= ROOM WISE PAYMENT BREAKUP ================= */}
                                <h5 className="fw-bold mt-3">
                                    Room wise Payment Breakup <small className="text-muted">(in ₹)</small>
                                </h5>

                                <div className="table-responsive ">
                                    <table className="table table-bordered align-middle text-center">
                                        <thead className="table-light">
                                            <tr>

                                                <th>Meal Plan </th>
                                                <th>Rate Plan</th>
                                                <th>ADULT(S)</th>
                                                <th>CHILD</th>
                                                <th>Extra Adl/Chl </th>
                                                <th>Room Rate</th>
                                                <th>Taxes </th>
                                                <th>Net Rate </th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {rooms.map((room, index) => {
                                                const showHeader =
                                                    index === 0 || rooms[index - 1].RoomName !== room.RoomName;
                                                return [
                                                    showHeader && (
                                                        <tr key={`header-${index}`} className="table-secondary">
                                                            <td colSpan="8" className="text-start fw-bold">
                                                                {room.RoomName}
                                                            </td>
                                                        </tr>
                                                    ),

                                                    <tr key={`row-${index}`}>
                                                        <td className='text-start'>{room.MeelPlan}</td>
                                                        <td className='text-start'>{room.RatePlan}</td>
                                                        <td>{room.adults}</td>
                                                        <td>{room.Child}</td>
                                                        <td>{room.ExtaCharge}</td>
                                                        <td>{room.RoomRate}</td>
                                                        <td>{room.TaxRate}</td>
                                                        <td>{room.NetAmount}</td>
                                                    </tr>
                                                ];
                                            })}

                                        </tbody>
                                        <tfoot>
                                            <tr className="fw-bold table-light">
                                                <td className="text-start">GRAND TOTAL</td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td>{bookingInfo?.TotalPayment}</td>
                                                <td>{bookingInfo?.Tax}</td>
                                                <td>{bookingInfo?.TotalAfterTax}</td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>


                                <div className="bg-light p-3">
                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <p className="text-muted mb-1">Booking Comment </p>
                                            <p className="fw-bold">{header?.BookingComment && JSON.parse(header.BookingComment)[0]?.BookingComment}</p>
                                        </div>

                                        <div className="col-md-6">
                                            <p className="text-muted mb-1">Payment Comment</p>
                                            <p className="fw-bold">
                                                {header?.PaymentComment && JSON.parse(header.PaymentComment)[0]?.PaymentComment}
                                            </p>
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-md-3">
                                            <p className="text-muted mb-1">Email</p>
                                            <span >{header?.Email}</span>
                                        </div>

                                        <div className="col-md-4">
                                            <p className="text-muted mb-1">Address</p>
                                            <span> {header?.Address}</span>
                                        </div>

                                        <div className="col-md-2">
                                            <p className="text-muted mb-1">city</p>
                                            <p className="fw-bold">{header?.City}</p>
                                        </div>

                                        <div className="col-md-2">
                                            <p className="text-muted mb-1">Country</p>
                                            <p className="fw-bold">{header?.Country}</p>
                                        </div>
                                    </div>


                                    <div className="row mb-3">
                                        <div className="col-md-2">
                                            <p className="text-muted mb-1">State</p>
                                            <p className="fw-bold">{header?.State}</p>
                                        </div>

                                        <div className="col-md-3">
                                            <p className="text-muted mb-1">Company Name</p>
                                            <p className="fw-bold">{bookingInfo?.CompanyName}</p>
                                        </div>

                                        <div className="col-md-2">
                                            <p className="text-muted mb-1">Registration Number </p>
                                            <p className="fw-bold">{header?.RegTax_Number}</p>
                                        </div>

                                        <div className="col-md-3">
                                            <p className="text-muted mb-1">Registered Company name</p>
                                            <p className="fw-bold">{header?.Reg_CompName}</p>
                                        </div>
                                    </div>


                                    <div className="row mb-3">
                                        <div className="col-md-4">
                                            <p className="text-muted mb-1">Registered Company address </p>
                                            <p className="fw-bold">{header?.RegCom_Address}</p>
                                        </div>

                                        <div className="col-md-3">
                                            <p className="text-muted mb-1">Billing Instructions</p>
                                            <p className="fw-bold"></p>
                                        </div>

                                        <div className="col-md-2">
                                            <p className="text-muted mb-1">Market Segment </p>
                                            <p className="fw-bold">{bookingInfo?.MarketSegment}</p>
                                        </div>


                                        <div className="col-md-3">
                                            <p className="text-muted mb-1">Business Source</p>
                                            <p className="fw-bold">{bookingInfo?.BusinessSource}</p>
                                        </div>

                                    </div>

                                    <div className="row mb-3">


                                        <div className="col-md-3">
                                            <p className="text-muted mb-1">Guarantee Codes </p>
                                            <p className="fw-bold">{bookingInfo?.GuaranteeCodes}</p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
